import type { Encounter } from '@/modules/encounter/types/encounter.types'

function getEncounterSpecialisation(encounter?: Encounter): string {
  return encounter ? (encounter.meta?.specialisation?.title ?? encounter.meta?.synops?.specialisation?.title ?? '') : ''
}

export { getEncounterSpecialisation }
